import {Input} from '@heroui/react';
import {AppParamsContext} from 'contexts/AppParamsContext';
import {useContext} from 'react';

export default function CustomInput(props) {
	const {appParams} = useContext(AppParamsContext);

	const handleCancel = () => {
		if (typeof props.onCancel === 'function') props.onCancel();
	};

	return (
		<div className='flex items-center w-full '>
			<Input
				aria-label='input'
				classNames={{
					inputWrapper: 'bg-inputBackground text-inputText border-1 border-inputBorder rounded-general',
					label: `${appParams?.styles?.fonts?.capitalize ? 'font-bold uppercase' : ''} group-data-[filled-within=true]:text-inputText  text-inputText group-data-[filled-within=true]:text-[12px]`,
				}}
				fullWidth={true}
				type='text'
				{...props}
			/>
		</div>
	);
}
